import React, { PureComponent } from 'react';
import { theme, css } from 'constants';
import { Text, View, TimeStamp } from 'core';
import { lang } from 'lang';
import { SYS_MSG as TYPES } from 'constants';
import { NewGroup } from './msgs';

const styles = css({
    new_group_container: {
        marginBottom: 100
    },
    contianer: {
        backgroundColor: theme.success_color_lighten(),
        margin: 10,
        maxWidth: 350,
        padding: 10,
        borderRadius: 10,
        alignSelf: 'center'
    },
    title: {
        textAlign: 'center',
        fontSize: theme.font_sm
    },
    user: {
        fontSize: theme.font_xs,
        color: theme.gray_color_alpha(0.7)
    },
    footer: {
        alignSelf: 'center',
        marginTop: 5,
        flexDirection: 'row'
    },
    time: {
        marginLeft: 3
    }
});
const red = theme.error_color_lighten();
const green = theme.success_color_lighten();
const gray = theme.gray_color_lighten(0.05);
//const blue = theme.primary_color_lighten();
const yellow = theme.warning_color_lighten();

const default_bg = theme.success_color_lighten();

const createSystemMsg = (bg_color, Comp, style) =>
    class extends PureComponent {
        render() {
            const { current_msg, name } = this.props;
            const title = lang.SYSTEM_MSG[current_msg.type](current_msg);

            return (
                <View>
                    <View style={[styles.contianer, { backgroundColor: bg_color || default_bg }, style]}>
                        {Comp ? <Comp current_msg={current_msg} /> : <Text style={styles.title}>{title}</Text>}
                        <View style={styles.footer}>
                            <Text style={styles.user}>
                                {lang.NOTIFICAION_BASE_FOOTER(name)}
                                <TimeStamp value={current_msg.created} style={styles.time} only_time />
                            </Text>
                        </View>
                    </View>
                </View>
            );
        }
    };

const system_types = {
    [TYPES.GROUP_CREATED]: createSystemMsg(green, NewGroup, styles.new_group_container),
    [TYPES.GROUP_UPDATED]: createSystemMsg(green),
    [TYPES.GROUP_OPENED]: createSystemMsg(green),
    [TYPES.GROUP_CLOSED]: createSystemMsg(gray),
    [TYPES.MAKE_ADMIN]: createSystemMsg(yellow),
    [TYPES.UNMAKE_ADMIN]: createSystemMsg(gray),
    [TYPES.ADD_TASK]: createSystemMsg(red),
    [TYPES.UPDATE_TASK]: createSystemMsg(red),
    [TYPES.REMOVE_TASK]: createSystemMsg(gray),
    [TYPES.ADD_MATERIAL]: createSystemMsg(green),
    [TYPES.UPDATE_MATERIAL]: createSystemMsg(green),
    [TYPES.REMOVE_MATERIAL]: createSystemMsg(gray),
    [TYPES.USER_JOINED]: createSystemMsg(green),
    [TYPES.USER_REJOINED]: createSystemMsg(green),
    [TYPES.USER_LEFT]: createSystemMsg(gray),
    [TYPES.MEMBER_BLOCKED]: createSystemMsg(gray),
    [TYPES.MEMBER_UNBLOCKED]: createSystemMsg(gray),
    [TYPES.MEMBER_REMOVED]: createSystemMsg(gray),
    [TYPES.GROUP_AVATAR_CHANGED]: createSystemMsg(green)
};

export default system_types;



// WEBPACK FOOTER //
// ./src/components/middle/chat/system_msg.js